import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { Amplify } from '@aws-amplify/core';
import { BrowserRouter } from 'react-router-dom';

Amplify.configure({
  Auth: {
    region: 'us-east-1',
    userPoolId: 'us-east-1_KDfe8aGru',  // From tofu output
    userPoolWebClientId: '5hvdjm1ttdm5ssv0q02eejljhs',  // From tofu output
    mandatorySignIn: true,
    oauth: {
      domain: 'blend-auth-tg7gut9x.auth.us-east-1.amazoncognito.com',  // From tofu output, e.g., blend-auth-xyz.auth.us-east-1.amazoncognito.com
      scope: ['email', 'openid', 'profile'],
      redirectSignIn: 'https://blend.palpateam.net/callback',
      redirectSignOut: 'https://blend.palpateam.net/logout',
      responseType: 'code'
    }
  }
});

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);